import { render, staticRenderFns } from "./PostingFiltersV2.vue?vue&type=template&id=f7587d36"
import script from "./PostingFiltersV2.vue?vue&type=script&lang=ts"
export * from "./PostingFiltersV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7587d36')) {
      api.createRecord('f7587d36', component.options)
    } else {
      api.reload('f7587d36', component.options)
    }
    module.hot.accept("./PostingFiltersV2.vue?vue&type=template&id=f7587d36", function () {
      api.rerender('f7587d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recruitings/PostingFiltersV2.vue"
export default component.exports